// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { listTree16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-list-tree': IconListTree;
    }
}

/**
 * The icon component for the 'listTree' icon
 */
export class IconListTree extends Icon {
    public constructor() {
        super(listTree16X16);
    }
}

registerIcon('icon-list-tree', IconListTree);
export const iconListTreeTag = 'nimble-icon-list-tree';
